import React, { ReactNode, useMemo } from "react";

import { defaultFakeStores, IStores, StoreContext } from "./StoreContext";

interface IStoreProviderProps {
    stores: IStores;
    children: ReactNode;
}

export function StoreProvider(props: IStoreProviderProps) {
    const { children, stores } = props;
    return (
        <StoreContext.Provider value={stores}>{children}</StoreContext.Provider>
    );
}

interface ITestStoreProviderProps {
    stores: Partial<IStores>;
    children: ReactNode;
}

export function TestStoreProvider(props: ITestStoreProviderProps) {
    const { stores, children } = props;
    const actualStores = useMemo(
        () => ({
            ...defaultFakeStores,
            ...stores,
        }),
        [],
    );

    return (
        <StoreContext.Provider value={actualStores}>
            {children}
        </StoreContext.Provider>
    );
}
